module.exports = __webpack_public_path__ + "img/ic-search.82bfb283.svg";